// FAMILY-EXT: форматирование длительности в человекочитаемый русский вид.
// Например: 1234567 ms → "20 мин", 3700000 ms → "1 ч 1 мин",
// 90000000 ms → "1 д 1 ч".

// Парсинг timestamp с сервера в ms. Sails/sails-postgresql иногда
// возвращают ISO-строку без 'Z' или '+NN:NN' (например,
// "2026-05-10T11:00:00.000"). JS-движок тогда считает её локальным
// временем — получаем сдвиг на TZ пользователя. Если индикатора часового
// пояса в строке нет — считаем её UTC и дописываем 'Z'.
export function parseServerTimestamp(value) {
  if (value == null) return NaN;
  if (typeof value === 'number') return value;
  if (value instanceof Date) return value.getTime();
  let s = String(value);
  if (!/Z|[+-]\d{2}:?\d{2}$/.test(s)) {
    s += 'Z';
  }
  return new Date(s).getTime();
}

export function formatDurationRu(ms) {
  if (!ms || ms < 0) return '0 мин';
  const sec = Math.floor(ms / 1000);
  const days = Math.floor(sec / 86400);
  const hours = Math.floor((sec % 86400) / 3600);
  const mins = Math.floor((sec % 3600) / 60);

  if (days > 0) {
    return hours > 0 ? `${days} д ${hours} ч` : `${days} д`;
  }
  if (hours > 0) {
    return mins > 0 ? `${hours} ч ${mins} мин` : `${hours} ч`;
  }
  if (mins > 0) return `${mins} мин`;
  return 'меньше минуты';
}
